import { io, Socket } from 'socket.io-client';
import firebase from 'firebase';

import { store } from "../redux/storeConfig/store";
import { API_ENTREGAS_SOCKET } from '../Constants';

async function getFirebaseIdToken(): Promise<string> {
  const { contributor } = store.getState();
  const auth = firebase.auth();

  if (auth && auth.currentUser) {
    const tokenIdFirebase = await auth.currentUser.getIdToken(true);

    return tokenIdFirebase;
  } else if (contributor && contributor.tokenIdFirebase) {
    return contributor.tokenIdFirebase;
  }

  return 'Does not have a token';
}

function getCity(): string {
  const { company } = store.getState();

  return company.address.city;
}

let socket: Socket;

export async function configSocket(): Promise<void> {
  const token = await getFirebaseIdToken();
  const city = getCity();

  socket = io(API_ENTREGAS_SOCKET, {
    auth: {
      token
    },
    query: {
      city
    }
  });
}

export function useSocket(): Socket {
  return socket;
}